export const MOVIMENTO_TABS = {
    CABECALHO: 'cabecalho',
    BALANCO: 'balanco',
    FINANCEIRO: 'financeiro',
    IMOVEL: 'imovel',
    ADITIVO: 'aditivo',
    ITENS: 'itens',
    LANCAMENTO: 'lancamento',
    ASSINATURA: 'assinatura',
    FRETE: 'frete',
    OBSERVACAO: 'observacao',
};
